import { render } from "./AuthUser.vue?vue&type=template&id=37fee212&scoped=true"
import script from "./AuthUser.vue?vue&type=script&lang=js"
export * from "./AuthUser.vue?vue&type=script&lang=js"

import "./AuthUser.vue?vue&type=style&index=0&id=37fee212&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fee212"]])

export default __exports__